import { format } from 'date-fns';

import { Storage } from '../enums';

export const toUTCDate = (date: number | Date) => {
  const parsedDate = new Date(date);
  return new Date(
    parsedDate.getUTCFullYear(),
    parsedDate.getUTCMonth(),
    parsedDate.getUTCDate(),
    parsedDate.getUTCHours(),
    parsedDate.getUTCMinutes(),
    parsedDate.getUTCSeconds(),
  );
};

export const formatInStandard = (date: number | Date, euFormat: string, usFormat: string) => {
  const userStandard = localStorage.getItem(Storage.CLASSIFICATION);

  if (userStandard === 'eu-standard') {
    return format(date, euFormat);
  }

  return format(date, usFormat);
};
